import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    IndicatorGeographiesDataViewResponse,
    IndicatorsAllEconomicDataViewResponse,
} from 'IndicatorsApp/ts/interfaces/data-view-responses.interface';
import { EditWatchlistModalIndicator } from 'WatchlistApp/ts/features/edit-watchlist-modal/interfaces/edit-watchlist-modal-indicator.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class IndicatorsService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getIndicatorsAllEconomicData(): Observable<IndicatorsAllEconomicDataViewResponse> {
        const url: string = this.urlsService.INDICATORS.INDICATORS_ALL_ECONOMIC_DATA;
        return this.ajaxService.getDataObserveBody<IndicatorsAllEconomicDataViewResponse>(url);
    }

    /**
     * Given some search IDs from the indicators autocompleter, retrieves the fields needed for displaying
     * the indicators as part of a watchlist in the edit indicator watchlist modal.
     * @param searchIds: array of indicator IDs, e.g. ['I:USEHS', 'I:USUR', 'I:VIX']
     * @returns Observable<EditWatchlistModalIndicator[]> with the information for the requested indicators
     */
    getIndicatorsInfoForWatchlist(searchIds: string[]): Observable<EditWatchlistModalIndicator[]> {
        const params = { indicators: searchIds };
        return this.ajaxService.postJsonDataObserveBody<EditWatchlistModalIndicator[]>(
            this.urlsService.INDICATORS.INDICATORS_INFO_WATCHLIST,
            params
        );
    }

    getIndicatorsGeographiesData(regionType: string): Observable<IndicatorGeographiesDataViewResponse> {
        const urlParams = { regionType };
        const url: string = this.urlsService.getUrl(
            this.urlsService.INDICATORS.INDICATOR_GEOGRAPHIES_DATA_VIEW,
            urlParams
        );
        return this.ajaxService.getDataObserveBody<IndicatorGeographiesDataViewResponse>(url);
    }
}
